module.exports = "/_next/static/images/car-duotone-7d9ae8245432ca9cccc913b8066eefd1.svg";